import { Dialog } from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

export const Modal = ({ isOpen, onClose, children, size = 'md', ...props }: ModalProps & Omit<React.ComponentProps<typeof Dialog.Root>, 'open' | 'children'>) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(details: { open: boolean }) => !details.open && onClose()} size={size} {...props}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>{children}</Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export const ModalHeader = ({ children, ...props }: { children: ReactNode } & React.ComponentProps<typeof Dialog.Header>) => {
  return <Dialog.Header {...props}>{children}</Dialog.Header>;
};

export const ModalBody = ({ children, ...props }: { children: ReactNode } & React.ComponentProps<typeof Dialog.Body>) => {
  return <Dialog.Body {...props}>{children}</Dialog.Body>;
};

export const ModalFooter = ({ children, ...props }: { children: ReactNode } & React.ComponentProps<typeof Dialog.Footer>) => {
  return <Dialog.Footer {...props}>{children}</Dialog.Footer>;
};

export const ModalCloseTrigger = ({ children, ...props }: { children?: ReactNode } & React.ComponentProps<typeof Dialog.CloseTrigger>) => {
  return <Dialog.CloseTrigger {...props}>{children}</Dialog.CloseTrigger>;
};

// Export as namespace for Modal.Header, Modal.Body, etc.
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.CloseTrigger = ModalCloseTrigger;
